<template>
  <div>
    <div v-if="regularColors.length > 0" class="row slider">
      <div class="col-sm-12">
        {{ step.label }}
      </div>
      <div v-for="(color, index) in regularColors" :key="index" class="col-sm-4 col-6">
        <color-option :option="color" @click.native="selectColor(color)" />
      </div>
    </div>

    <div v-if="specialColors.length > 0" class="row slider">
      <div class="col-sm-12">
        <p>{{ step.label_special }} (+{{ step.price_special }}%)</p>
      </div>
      <div v-for="(color, index) in specialColors" :key="index" class="col-sm-4 col-6">
        <color-option :option="color" @click.native="selectColor(color)" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ColorOption from './colorOption'

export default {
  components: {
    ColorOption
  },
  computed: {
    ...mapGetters({
      step: 'configurator/currentStep'
    }),
    regularColors () {
      return this.step.colors.filter(c => !c.special && c.visible)
    },
    specialColors () {
      return this.step.colors.filter(c => c.special && c.visible)
    }
  },
  methods: {
    ...mapActions({
      selectColor: 'configurator/selectColor'
    })
  }
}
</script>
